import { Navigate, Route, Routes } from 'react-router-dom';
import { HELP_SUB_ROUTES } from './const';
import { HelpCenter } from './HelpCenter';
import { SendConsult } from './SendConsult';
import { TermsAndConditions } from './TermsAndConditions';

const subRoutes = [
    {
        path: HELP_SUB_ROUTES.TERMS_AND_CONDITIONS,
        Component: <TermsAndConditions />,
    },
    {
        path: HELP_SUB_ROUTES.SEND_CONSULT,
        Component: <SendConsult />,
    },
    {
        path: HELP_SUB_ROUTES.HELP_CENTER,
        Component: (
            <HelpCenter
                questions={[
                    {
                        title: '¿Lorem ipsum dolor sit amet, consectetur adipiscing?',
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatu',
                    },
                    {
                        title: '¿Lorem ipsum dolor sit amet, consectetur adipiscing?',
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatu',
                    },
                    {
                        title: '¿Lorem ipsum dolor sit amet, consectetur adipiscing?',
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatu',
                    },
                ]}
            />
        ),
    },
];

export const Help = () => {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='/' />} />
            {subRoutes.map((route) => (
                <Route
                    key={`help-route--${route.path}`}
                    path={route.path}
                    element={route.Component}
                />
            ))}
        </Routes>
    );
};
